<!-- =========================================================================================
  File Name: TheNavbar.vue
  Description: Navbar component
  Component Name: TheNavbar
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
  <div class="relative">

    <div class="vx-navbar-wrapper" :class="classObj">

      <vs-navbar class="vx-navbar navbar-custom navbar-skelton" :color="navbarColorLocal" :class="textColor">

        <router-link tag="div" to="/" class="vx-logo cursor-pointer mx-auto flex items-center">
          <logo class="w-8 mr-4 fill-current text-primary" />
        </router-link>
        <span>{{eventName}} - {{$t('ForAssistance')}}</span>
        
        <vs-spacer />
        <vs-button data-tour='step-8' class='mr-2' @click.prevent.stop='startTheTour' :disabled='isTourStarted'>{{ $t("START_TOUR") }}</vs-button>

        <!--<i18n />-->

        <profile-drop-down-home />

      </vs-navbar>
    </div>
  </div>
</template>

<style scoped>
.vx-navbar-wrapper {
    position: inherit;
    width: 100% !important;
}
.vx-logo .vx-logo-text {
    font-size: 16px;
    font-weight: 600;
}
</style>
<script>
import Bookmarks            from "./components/Bookmarks.vue"
import I18n                 from './components/I18n.vue'
import SearchBar            from "./components/SearchBar.vue"
import NotificationDropDown from "./components/NotificationDropDown.vue"
import ProfileDropDownHome      from "./components/ProfileDropDownHome.vue"
import Logo                 from "../Logo.vue"
import { mapGetters } from 'vuex';


export default {
  name: "the-navbar-vertical-home",
  props: {
    navbarColor: {
      type: String,
      default: "#fff",
    },
  },
  data() {
      return {
        eventName : 'Concilium WEB'
      }
  },
  components: {
    Bookmarks,
    I18n,
    SearchBar,
    NotificationDropDown,
    ProfileDropDownHome,
    Logo
  },
  computed: {
    ...mapGetters([
      'isTourStarted'
		]),
    navbarColorLocal() {
      return this.$store.state.app.theme === "dark" && this.navbarColor === "#fff" ? "#10163a" : this.navbarColor
    },
    verticalNavMenuWidth() {
      return this.$store.state.app.verticalNavMenuWidth
    },
    textColor() {
      return {'text-white': (this.navbarColor != '#10163a' && this.$store.state.app.theme === 'dark') || (this.navbarColor != '#fff' && this.$store.state.app.theme !== 'dark')}
    },
    windowWidth() {
      return this.$store.state.app.windowWidth
    },

    // NAVBAR STYLE
    classObj() {
      if (this.verticalNavMenuWidth == "default")      return "navbar-default"
      else if (this.verticalNavMenuWidth == "reduced") return "navbar-reduced"
      else if (this.verticalNavMenuWidth)              return "navbar-full"
    },
    getEventName() {
      return this.$store.getters.eventName
    }
  },
  watch: {
    getEventName: function(newValue) {
      this.eventName = newValue
    },
  },
  methods: {
    startTheTour() {
      this.$store.dispatch('setIsTourStarted', true);
      this.$router.push('/')
    },
    showSidebar() {
      this.$store.commit('TOGGLE_IS_VERTICAL_NAV_MENU_ACTIVE', true);
    }
  }
}
</script>

